import _debounce from "lodash.debounce"
export default {
  methods: {
    validateInputDefer: _debounce(function (event, type) {
      const value = event.target?.value || (event.path ? event.path[0].value : "")
      this.validateInput(value, type)
    }, 200),
  },
}
